import Image from "next/image";
import "react-image-crop/dist/ReactCrop.css";
import Button from "@/components/UI/Button/Button";
import Link from "@/components/UI/Link/Link";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section04Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const TitleOnLeftAndImageOnRightWithButton = ({ job, page, section, ...props }: Section04Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer className="flex-row" section={section}>
        <div className="flex flex-1 flex-col gap-10">
          <SectionHeader className="text-left" section={section} />
          {section?.List?.length > 0 && (
            <ul className="flex flex-col gap-2">
              {section?.List?.map((item: any) => {
                return (
                  <li className="flex items-center gap-2" key={item?.id}>
                    {item?.Url ? (
                      <Link
                        className="text-lg"
                        href={item?.Url ?? ""}
                        startNode={
                          item?.StartNode?.data?.attributes && (
                            <Image
                              alt={item?.StartNode?.data?.attributes?.alternativeText}
                              className="h-5 w-5"
                              height={item?.StartNode?.data?.attributes?.height}
                              src={item?.StartNode?.data?.attributes?.url ?? "100"}
                              width={item?.StartNode?.data?.attributes?.width ?? "100"}
                            />
                          )
                        }
                        variant="external"
                      >
                        {item?.Value}
                      </Link>
                    ) : (
                      <>
                        {item?.StartNode?.data?.attributes && (
                          <Image
                            alt={item?.StartNode?.data?.attributes?.alternativeText}
                            className="h-5 w-5"
                            height={item?.StartNode?.data?.attributes?.height}
                            src={item?.StartNode?.data?.attributes?.url ?? "100"}
                            width={item?.StartNode?.data?.attributes?.width ?? "100"}
                          />
                        )}
                        <span className="text-lg">{item?.Value}</span>
                      </>
                    )}
                  </li>
                );
              })}
            </ul>
          )}
          {section?.Highlights?.length > 0 && (
            <div className="flex gap-10">
              {section?.Highlights?.map((item: any) => {
                return (
                  <div className="flex flex-col gap-2" key={item?.id}>
                    <div className="text-5xl font-bold">{item?.Title}</div>
                    <div className="text-lg">{item?.Subtitle}</div>
                  </div>
                );
              })}
            </div>
          )}
          {section?.Button && (
            <Link className="block" href={section?.Button?.Url ?? ""} variant="external">
              <Button size="large">{section?.Button?.Value}</Button>
            </Link>
          )}
        </div>
        {section?.Image?.data?.attributes && (
          <div className="hidden lg:block lg:flex-1">
            <Image
              alt={section?.Image?.data?.attributes?.alternativeText}
              src={section?.Image?.data?.attributes?.url}
              width={section?.Image?.data?.attributes?.width ?? "100"}
              height={section?.Image?.data?.attributes?.width ?? "100"}
              priority
            />
          </div>
        )}
      </SectionContainer>
    </Section>
  );
};

export default TitleOnLeftAndImageOnRightWithButton;
